import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding, getLspDetails, LspUpdatation } from "./lspSlice";
import { fetchServices } from "../../../components/global-entities/globalEntitiesSlice";
import { fetchAllEntites } from "../../MyEntityDashboard/myEntityDashboardSlice";

const useLspPortfolioUpdate = () => {
  const dispatch = useDispatch();
  const refPanel = useRef(null);

  const {
    entityLists,
    selectedServices,
    lspdetails,
    accesspaginationFirst,
    accesspaginationRows,
    isDeleteAccesModal = false,
    deleteEntity,
  } = useSelector((state) => state.lsponboarding);
  const { allentites } = useSelector((state) => state.myentitydashboard);

  const { entityservices } = useSelector((state) => state.globalEntities);
  const [updatEntity, setIsUpdatEntity] = useState([]);
  const [accessList, setAccessList] = useState(null);
  const [updateBtnAvailbel, setUpdateBtnAvailbel] = useState(false);
  const [updateMsg, setUpdateMsg] = useState("");
  const [isLoadSelect, setIsLoadSelect] = useState(false);
  const [removedMsg, setRemovedMsg] = useState("");
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchAllEntites());
    dispatch(fetchServices());
    setIsLoadSelect(false);
  }, [dispatch]);

  useEffect(() => {
    let { access } = lspdetails || {};
    const checkedServices = access?.map((item) => ({
      entity_id: item.entity.id,
      services: item.services.map((service) => service.id),
    }));
    dispatch(
      setLspOnboarding({ key: "selectedServices", value: checkedServices }),
    );
    setAccessList(access);
  }, [lspdetails]);

  useEffect(() => {
    filterEntities(allentites);
  }, [allentites]);

  useEffect(() => {
    let flag = false;
    for (let updateItem of updatEntity) {
      const userEntity = accessList.find(
        (item) => item.entity.id === updateItem.entityId,
      );
      if (userEntity) {
        const serviceExists = userEntity.services.some(
          (service) => service.id === updateItem.serviceId,
        );
        if (
          (updateItem.checked && !serviceExists) ||
          (!updateItem.checked && serviceExists)
        ) {
          flag = true;
          break;
        }
      } else {
        flag = true;
        break;
      }
    }
    setUpdateBtnAvailbel(flag);
  }, [updatEntity]);

  const filterEntities = (entities) => {
    const availableEntities = entities?.filter(
      (entity) => entity?.active_services?.length > 0,
    );
    dispatch(
      setLspOnboarding({ key: "entityLists", value: availableEntities }),
    );
  };

  const openDeleteModal = (data) => {
    dispatch(setLspOnboarding({ key: "isDeleteAccesModal", value: true }));
    dispatch(setLspOnboarding({ key: "deleteEntity", value: data }));
  };
  const closeDeleteModal = () => {
    dispatch(setLspOnboarding({ key: "isDeleteAccesModal", value: false }));
    dispatch(setLspOnboarding({ key: "deleteEntity", value: null }));
  };
  const handleSetMenu = (event) => refPanel?.current?.toggle(event);
  const handleCloseMenu = () => refPanel?.current?.hide();

  const handleSelection = () => {
    let data = {
      id: lspdetails?.id,
      access: selectedServices.filter((item) => item.services.length > 0),
    };
    setIsLoadSelect(true);
    dispatch(LspUpdatation(data)).then(() => {
      setUpdateMsg("Customer portfolio has been successfully updated.");
      setAccessList(null);
      handleCloseMenu();
      closeDeleteModal();
      setUpdateBtnAvailbel(false);
      setIsLoadSelect(false);
      dispatch(getLspDetails(lspdetails?.id));
    });
  };

  const searchEntity = (searchTerm) => {
    const filtered = allentites.filter((entity) =>
      entity.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    filterEntities(filtered);
  };

  const handlSelectedService = (event, entityId, serviceId) => {
    const existingEntity = selectedServices.find(
      (service) => service.entity_id === entityId,
    );
    if (existingEntity) {
      const updatedServices = event
        ? [...new Set([...existingEntity.services, serviceId])]
        : existingEntity.services.filter((id) => id !== serviceId);

      if (updatedServices.length === 0) {
        const ser = selectedServices.filter(
          (service) => service.entity_id !== entityId,
        );
        dispatch(setLspOnboarding({ key: "selectedServices", value: ser }));
      }
      const d = selectedServices.map((service) =>
        service.entity_id === entityId
          ? { ...service, services: updatedServices }
          : service,
      );
      dispatch(setLspOnboarding({ key: "selectedServices", value: d }));
    } else {
      const d = event
        ? [...selectedServices, { entity_id: entityId, services: [serviceId] }]
        : selectedServices;

      dispatch(setLspOnboarding({ key: "selectedServices", value: d }));
    }
  };
  const deleteUserAccess = () => {
    handleCloseMenu();
    let data = {
      id: lspdetails?.id,
      access: selectedServices.filter(
        (item) => item.entity_id !== deleteEntity?.id,
      ),
    };
    setIsLoadSelect(true);

    dispatch(LspUpdatation(data)).then(() => {
      setRemovedMsg(
        `${deleteEntity?.name} have been removed from the customer profile`,
      );
      setIsLoadSelect(false);
      setAccessList(null);
      closeDeleteModal();
      setUpdateBtnAvailbel(false);
      dispatch(getLspDetails(lspdetails?.id));
    });
  };

  const paginationOnchange = (e) => {
    dispatch(
      setLspOnboarding({ key: "accesspaginationFirst", value: e.first }),
    );
    dispatch(setLspOnboarding({ key: "accesspaginationRows", value: e.rows }));
  };

  const hanleChangeUpdateAccess = (event, entityId, serviceId) => {
    handlSelectedService(event, entityId, serviceId);

    const exists = updatEntity.some(
      (item) => item.entityId === entityId && item.serviceId === serviceId,
    );

    if (!exists) {
      setIsUpdatEntity((prev) => [
        ...prev,
        {
          entityId: entityId,
          serviceId: serviceId,
          checked: event,
        },
      ]);
    } else {
      let updatedList = updatEntity.map((item) =>
        item.entityId === entityId && item.serviceId === serviceId
          ? { ...item, checked: event }
          : item,
      );
      setIsUpdatEntity(updatedList);
    }
  };
  const handleDiscardUpdate = () => {
    for (let x of updatEntity) {
      handlSelectedService(false, x.entityId, x.serviceId);
    }
    setIsUpdatEntity([]);
  };
  return {
    statevalues: {
      refPanel,
      entityservices,
      entityLists,
      selectedServices,
      accessList,
      isDeleteAccesModal,
      deleteEntity,
      accesspaginationFirst,
      accesspaginationRows,
      updatEntity,
      updateBtnAvailbel,
      updateMsg,
      removedMsg,
      isAuditSidebarVisible,
      isLoadSelect,
    },
    handleSelection,
    handleSetMenu,
    handleCloseMenu,
    searchEntity,
    handlSelectedService,
    openDeleteModal,
    closeDeleteModal,
    deleteUserAccess,
    paginationOnchange,
    hanleChangeUpdateAccess,
    handleDiscardUpdate,
    setUpdateMsg,
    setRemovedMsg,
    setAuditSidebarVisible,
  };
};

export default useLspPortfolioUpdate;
